import { createBrowserHistory } from 'history';

export const myHistory = createBrowserHistory();